function placesSection() {
  //searching
  jQuery.expr[':'].icontains = function (a, i, m) {
    return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
  };

  $('#places-input-search').keyup(function (event) {
    var value = $(this).val();
    if (value.length > 3) {
      $('.place-title:not(:icontains("' + value + '"))')
        .closest('.places-col')
        .hide();
      $('.place-title:not(:icontains("' + value + '"))').hide();
      var elements = $('.place-title:icontains("' + value + '")');
      elements.each(function () {
        $(this).closest('.places-col').show();
      });
      elements.show();
    } else {
      $('.place-title').closest('.places-col').show();
      $('.place-title').show();
    }
  });

  const placesItems = $('.places-col');
  const showMoreButton = $('#show-more');
  const customSelect = $('.custom-select');

  showMoreButton.on('click', function () {
    placesItems.each(function () {
      $(this).removeClass('is-hidden');
    });
    showMoreButton.addClass('is-hidden');
  });

  customSelect.on('click', function () {
    let selectedValue = customSelect.find('.select-selected').text();
    if (selectedValue !== 'Zobrazit vše') {
      placesItems.each(function () {
        if ($(this).data('category') === selectedValue) {
          $(this).removeClass('is-hidden');
        } else {
          $(this).addClass('is-hidden');
        }
      });
    } else {
      placesItems.each(function () {
        $(this).removeClass('is-hidden');
      });
    }
  });
}
